// Single source of truth for lender phone/postal-code normalization and validation.
// Lives in shared-ui-utils (a lower-level lib) so both the lender validation config here and
// dash-components can consume it without a shared-ui-utils -> dash-components cycle.

const MAX_PHONE_LENGTH = 10;
const MIN_PHONE_LENGTH = 3;
const MAX_POSTAL_CODE_LENGTH = 9;

export const normalizeLenderPhone = (value: string | undefined | null): string => {
    if (!value) return '';

    const unformatted = value.replace(/[-\s()]/g, '');

    const digitsOnly = unformatted.replace(/\D/g, '');

    if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
        return digitsOnly.substring(1);
    }

    return digitsOnly;
};

export const validateLendersListPhone = (value: string | undefined | null): boolean => {
    if (!value) return false;
    const digitsOnly = normalizeLenderPhone(value);
    return digitsOnly.length === MAX_PHONE_LENGTH;
};

export const validateLendersListPhoneWithAreaCode = (value: string | undefined | null): boolean => {
    if (!value) return false;
    const digitsOnly = normalizeLenderPhone(value);
    return digitsOnly.length >= MIN_PHONE_LENGTH && digitsOnly.length <= MAX_PHONE_LENGTH;
};

export const getValidLenderPhone = (value: string | undefined | null): string | null => {
    if (!value) return null;

    const digitsOnly = normalizeLenderPhone(value);

    if (digitsOnly.length !== MAX_PHONE_LENGTH) {
        return null;
    }

    return digitsOnly;
};

/**
 * Normalizes lender postal code for the Deal API by removing the dash from
 * #####-#### format. The Deal API accepts a maximum of 9 characters for postalCode.
 */
export const normalizeLenderPostalCode = (value: string | undefined | null): string => {
    if (!value) return '';
    return value.replace(/-/g, '');
};

/**
 * Returns the lender postal code for the Deal API if valid (9 characters after removing dash).
 * Otherwise returns null. Use this when building the payload so invalid postal codes are sent as null.
 */
export const getValidLenderPostalCode = (value: string | undefined | null): string | null => {
    const normalized = normalizeLenderPostalCode(value);
    if (normalized.length > MAX_POSTAL_CODE_LENGTH) {
        return null;
    }
    return normalized;
};
